import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import { useBackdropContext } from '../../../../context/backdrop';
import { useGraphqlContext } from '../../../../context/graphql';
import { environment } from '../../../../environment';
import { useErrors } from '../../../../hooks/errors/use-errors';
import { useHttpClient, useRestClient } from '../../../../utils/clients/rest-client';
import { TimeZonePayload, TimeZoneResponse } from './installation.types';

export const useGetTimeZones = () => {
  const restClient = useRestClient({ noInstallationIdHeader: true });
  const { handleRestErrors } = useErrors();
  const { turnOnBackdrop, turnOffBackdrop } = useBackdropContext();

  return useQuery<TimeZonePayload[], AxiosError>(
    'query-time-zones',
    async () => {
      turnOnBackdrop();
      const response = await restClient.get<TimeZoneResponse>('/api/time-zones.json', {
        baseURL: environment.PUBLIC_URL,
      });

      turnOffBackdrop();
      return response.data.zones;
    },
    {
      enabled: true,
      retry: false,
      onError: (error: AxiosError) => {
        handleRestErrors(error);
      },
    },
  );
};

export const useGetBrokerToCreateInstallation = () => {
  const httpClient = useHttpClient({ noInstallationIdHeader: true });
  const { updateBrokerUrl } = useGraphqlContext();
  const { turnOnBackdrop, turnOffBackdrop } = useBackdropContext();

  const getBroker = async () => {
    try {
      turnOnBackdrop();
      const { data } = await httpClient.brokerInfo.brokerInfoNextBrokers(1);

      if (data.length) updateBrokerUrl(data[0].brokerExternalUrl);
      turnOffBackdrop();
    } catch (error) {
      turnOffBackdrop();
      console.log(error);
    }
  };

  return {
    getBroker,
  };
};

export const useGetInstallationBroker = () => {
  const httpClient = useHttpClient({ noInstallationIdHeader: true });
  const { updateBrokerUrl } = useGraphqlContext();
  const { turnOnBackdrop, turnOffBackdrop } = useBackdropContext();

  const getBroker = async (installationId: string) => {
    try {
      turnOnBackdrop();
      const { data } = await httpClient.brokerInstance.brokerInstanceDetail(installationId);

      if (data.brokerExternalUrl) updateBrokerUrl(data.brokerExternalUrl);
      turnOffBackdrop();
    } catch (error) {
      turnOffBackdrop();
      console.log(error);
    }
  };

  return {
    getBroker,
  };
};
